import React from 'react';
import { Heading1, Paragraph } from '../components/typography';
import { Container, Row, Col } from '../components/grid';
import { Image } from '../components/Image';
import SidemenuLayout from '../layout/DefaultLayout/Layouts/SidemenuLayout';

export default () => (
  <SidemenuLayout menuPicker="OmOs" activeSidemenu="Historie">
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading1>
            Bandit lastbil. Elektrisk, lav øl lastbil<br />
          </Heading1>
          <Paragraph>
            Projektet er stoppet. Følgende tekst fra 2010:
          </Paragraph>
          <Paragraph>
            Peter Skafte øl &amp; Vand i Brøndby går forrest med helt ny og revolutionerende lastbil, kaldet Bandit.
          </Paragraph>
          <Paragraph>
            Bilen er en stor gevinst for det fysiske
            arbejdsmiljø. Ved af og pålæsning sættes hele ladet
            direkte ned på jorden. Der er kun ladbundens tykkelse på
            8 cm som trin ind i bilen.
          </Paragraph>
          <Paragraph>
            Chaufføren kan med en lille rampe og løftevogn køre
            pallerne direkte ud på gaden. Ved mindre leverancer kan
            sækkevognen køre direkte ud og ind.
          </Paragraph>
          <Paragraph>
            Lastbilen drives af elektromotorer på baghjulene. Strømmen
            hertil leveres af en generator på den sædvanlige
            dieselmotor. Brændstofmotoren kører med næsten konstant
            lavt omdrejningstal, derfor er lastbilen mere
            økonomisk og mindre forurenende end almindelige distributionsbiler.
          </Paragraph>
          <Paragraph>Lastbilen rummer op til 14 paller med øl &amp; sodavand</Paragraph>
          <Paragraph>
            Der er let adgang til ladet gennem de 4
            elektriske og fjerntbetjente rullegardiner i siderne.
            Der er også mulighed for at åbne bagdørene.
          </Paragraph>
        </Col>
        <Col xs={12} textCenter>
          <Image name="diverse.bandit1.jpg" alt="Peter Skaftes lave lastbil kaldet Bandit" />
        </Col>
        <Col xs={12} textCenter>
          <Image name="diverse.bandit3.jpg" alt="Peter Skaftes arbejdsmiljøvenlige lave lastbil Banditten" />
        </Col>
        <Col xs={12} sm={6} textCenter>
          <Image name="diverse.bandit2.jpg" alt="Peter Skaftes lave lastbil ved producenten i Holland" />
        </Col>
        <Col xs={12} sm={6} textCenter>
          <Image name="diverse.bandit4.jpg" alt="Peter Skaftes diesel elektriske miljølastbil" />
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
